export default function CurrentTemp({ temp }) {
  if (!temp) return <div>Loading...</div>;
  return (
    <div style={{ fontSize: '4rem', margin: '1rem 0' }}>
      {temp.value_celsius.toFixed(1)}°C
    </div>
  );
}